import { Ajax } from "../Common/Ajax";
import { GlobalData } from "../Common/GlobalData";
import { HtmlHelpers } from "../Common/HtmlHelpers";
import { TemplateHelpers } from "../Common/KendoHelpers";

export class AccountsGainLoss {
    private static readonly REPORT_DATE = '#closingDate';
    private static readonly START_DATE = '#startDate';
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(AccountsGainLoss.START_DATE).kendoDatePicker();

        $(AccountsGainLoss.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_PERSONAL_ACCOUNTS_GAIN_LOSS_REPORT,
                }
            },
            dataBound: () => {
                const data = $(AccountsGainLoss.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    $(AccountsGainLoss.REPORT_DATE).html(
                        HtmlHelpers.getFormattedDate(data[0].closingDate));
                }

                // Bind the change event of the start date to refreshing the grid. We
                // wait until the grid data has already been bound so we don't end up
                // doing it twice.
                const datePicker = $(AccountsGainLoss.START_DATE).data('kendoDatePicker')!;
                datePicker.unbind('change').bind('change', () => {
                    this.refreshGrid();
                });
            },

            height: 915,
            groupable: false,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '9%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '23%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "close",
                    title: "Closing<br />Price",
                    width: '8%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: 'account',
                    title: 'Account',
                    width: '8%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "dateOpen",
                    title: "Date<BR />Opened",
                    width: '9%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px; font-weight: normal" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('dateOpen')),
                },
                {
                    field: "quantity",
                    title: "Qty",
                    width: "4%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n0}',
                },
                {
                    field: "costBasis",
                    title: "CostBasis",
                    width: "9%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "gainLoss",
                    title: "Gain/Loss",
                    width: "9%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}', //ToDo: Change the color of negative values to Red.
                },
                {
                    field: "percent",
                    title: "Percent",
                    width: "9%",
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:p1}',
                },
                {
                    field: 'holdPeriod',
                    title: 'Hold<BR />Period',
                    width: '8%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'tableName',
                    title: 'Table<BR />Name',
                    width: '5%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
            ]
        });
    }

    private refreshGrid() {
        const datePicker = $(AccountsGainLoss.START_DATE).data('kendoDatePicker')!;
        const startDate = HtmlHelpers.getFormattedDate(datePicker.value().toDateString());
        const grid = $(AccountsGainLoss.GRID).data('kendoGrid')!;
        const urlSuffix = GlobalData.URL_SUFFIX_PERSONAL_ACCOUNTS_GAIN_LOSS_REPORT +
            '?startDate=' + startDate;

        const success = (data: any) => {
            grid.setDataSource(new kendo.data.DataSource({ data: data }));
        };

        const error = () => {
            // TODO_CAB: what to do on error?
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }
}
